import React from 'react';
import SingleChoose from '../../components/Choose';

import shapeImg from '../../assets/img/choose/shape-5-1.png';
import chooseImg1 from '../../assets/img/choose/choose-5-1.jpg';
import chooseImg2 from '../../assets/img/choose/choose-5-2.jpg';

const ChooseUs = () => {
  return (
    <div
      id="it-choose"
      className="it-choose-area it-choose-style-3 p-relative z-index pt-120 pb-170"
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-6 col-lg-6">
            <div className="it-choose-left p-relative">
              <div className="it-choose-shape-3 d-none d-xxl-block">
                <img src={shapeImg} alt="" />
              </div>
              <div className="it-choose-title-box mb-20">
                <span className="it-section-subtitle red-border">
                  Why choose Us?
                </span>
                <h3 className="it-section-title">
                  Take The Road To A Healthy <br /> Heart Beat
                </h3>
              </div>
              <div className="it-choose-text mb-25">
                <p>
                  Neque porro quisquam est, qui dolorem ipsum quia dolor sit
                  amet, consectetur, adipisci velit, sed quia non numquam eius
                  modi tempora incidunt ut labore et dolore magnam aliquam
                  quaerat voluptatem.
                </p>
              </div>
              <div className="row">
                <div className="col-lg-6 col-md-6 mb-15">
                  <SingleChoose
                    itemClass="it-choose-staff style-1 d-flex align-items-center"
                    icon="flaticon-cardiology"
                    title="Heart Personalized"
                    description="Standard dummy text ever since the unknown
                        printer took."
                  />
                </div>
                <div className="col-lg-6 col-md-6 mb-15">
                  <SingleChoose
                    itemClass="it-choose-staff style-2 d-flex align-items-center"
                    icon="flaticon-heart"
                    title="Professional Team"
                    description="Standard dummy text ever since the unknown
                        printer took."
                  />
                </div>
                <div className="col-lg-6 col-md-6">
                  <SingleChoose
                    itemClass="it-choose-staff style-1 d-flex align-items-center"
                    icon="flaticon-doctor-3"
                    title="Regularly checkup"
                    description="Standard dummy text ever since the unknown
                        printer took."
                  />
                </div>
                <div className="col-lg-6 col-md-6">
                  <SingleChoose
                    itemClass="it-choose-staff style-2 d-flex align-items-center"
                    icon="flaticon-robot"
                    title="Latest and Technology"
                    description="Standard dummy text ever since the unknown
                        printer took."
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-lg-6">
            <div className="it-choose-right p-relative text-end">
              <div className="it-choose-thumb p-relative">
                <img src={chooseImg1} alt="" />
              </div>
              <div className="it-choose-thumb-sm">
                <img src={chooseImg2} alt="" />
              </div>
              <div className="it-choose-experience">
                <div className="text-center">
                  <h6>16+</h6>
                  <span>Years experience</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChooseUs;
